import "./index.scss";
import { useWindowDimensions } from "hooks/useWindowDimensions";
import { GcxLogo } from "components/UI/molecules/gcx-logo";

export const CheckoutHeader = ({ step = 1 }) => {
  const { width } = useWindowDimensions();
  const isMobile = width < 768;

  return (
    <div className="checkout-header">
      <div className="header-container">
        <GcxLogo
          data-test-id="logo-small"
          version={isMobile ? "icon" : "small"}
        />
        <div
          className="desktop-steps"
          style={{
            backgroundPosition: `50% -${(step - 1) * 62}px`
          }}
        />
      </div>
    </div>
  );
};
